<template>
  <carousel-3d :autoplay="true" :controls-visible="true" :clickable="true" :width="500" :height="200">
    <slide v-for="(customer, index) in customers" :index="index" :key="index">
      <a  :href="customer.link">
        <div   class="card customer-card" :style="{width: '100%', height: '100%'}">
          <div style="width:100%;height:100%;display: flex; justify-content: center;  align-items: center; justify-content: center;">
            <img :alt="customer.name" :style="{'max-height': ( ( mobileBreakpointPx < $vssWidth ) ? '120px' : '70px'), 'max-width': ( ( mobileBreakpointPx < $vssWidth ) ? '280px' : '180px') ,'width':'auto', 'height':'auto' , 'transform': 'scale(1.5)'}" :src="baseFolder + customer.icon"/>
          </div>
        </div>
      </a>
    </slide>
  </carousel-3d>

</template>

<script>
import { Carousel3d, Slide } from 'vue-carousel-3d';
import VueScreenSize from 'vue-screen-size'

export default {
    name: 'CustomerSlider',
    mixins: [VueScreenSize.VueScreenSizeMixin],
    components: {
        Carousel3d,
        Slide
    },
    props: {
        mobileBreakpointPx: {
            Number,
            default: 769
        },
    
        baseFolder: {
            type: String,
            default: 'https://www.le-tex.de/img/'
        },
        customers: {
            type: Array,
            default: () => ([
                {link: 'https://www.le-tex.de', name: 'logo_adac.png', icon: 'logo_adac.png'},
                {link: 'https://www.le-tex.de', name: 'logo_akademie.png', icon: 'logo_akademie.png'},
                {link: 'https://www.le-tex.de', name: 'logo_arsEdition.png', icon: 'logo_arsEdition.png'},
                {link: 'https://www.le-tex.de', name: 'logo_aufbau.png', icon: 'logo_aufbau.png'},
                {link: 'https://www.le-tex.de', name: 'logo_bank.png', icon: 'logo_bank.png'},
                {link: 'https://www.le-tex.de', name: 'logo_beltz.png', icon: 'logo_beltz.png'},
                {link: 'https://www.le-tex.de', name: 'logo_beuth.png', icon: 'logo_beuth.png'},
                {link: 'https://www.le-tex.de', name: 'logo_boorberg.png', icon: 'logo_boorberg.png'},
                {link: 'https://www.le-tex.de', name: 'logo_bpb.png', icon: 'logo_bpb.png'},
                {link: 'https://www.le-tex.de', name: 'logo_campus.png', icon: 'logo_campus.png'},
                {link: 'https://www.le-tex.de', name: 'logo_chbeck.png', icon: 'logo_chbeck.png'},
                {link: 'https://www.le-tex.de', name: 'logo_compact.png', icon: 'logo_compact.png'},
                {link: 'https://www.le-tex.de', name: 'logo_cornelsen.png', icon: 'logo_cornelsen.png'},
                {link: 'https://www.le-tex.de', name: 'logo_dav.png', icon: 'logo_dav.png'},
                {link: 'https://www.le-tex.de', name: 'logo_deGruyter.png', icon: 'logo_deGruyter.png'},
                {link: 'https://www.le-tex.de', name: 'logo_desy.png', icon: 'logo_desy.png'},
                {link: 'https://www.le-tex.de', name: 'logo_din.png', icon: 'logo_din.png'},
                {link: 'https://www.le-tex.de', name: 'logo_eichborn.png', icon: 'logo_eichborn.png'},
                {link: 'https://www.le-tex.de', name: 'logo_emsph.png', icon: 'logo_emsph.png'},
                {link: 'https://www.le-tex.de', name: 'logo_engelsdorfer-verlag.png', icon: 'logo_engelsdorfer-verlag.png'},
                {link: 'https://www.le-tex.de', name: 'logo_friedrich.png', icon: 'logo_friedrich.png'},
                {link: 'https://www.le-tex.de', name: 'logo_gfn.png', icon: 'logo_gfn.png'},
                {link: 'https://www.le-tex.de', name: 'logo_hanser.png', icon: 'logo_hanser.png'},
                {link: 'https://www.le-tex.de', name: 'logo_herder.png', icon: 'logo_herder.png'},
                {link: 'https://www.le-tex.de', name: 'logo_hoca.png', icon: 'logo_hoca.png'},
                {link: 'https://www.le-tex.de', name: 'logo_hogrefe.png', icon: 'logo_hogrefe.png'},
                {link: 'https://www.le-tex.de', name: 'logo_infinitas.png', icon: 'logo_infinitas.png'},
                {link: 'https://www.le-tex.de', name: 'logo_karl-storz.png', icon: 'logo_karl-storz.png'},
                {link: 'https://www.le-tex.de', name: 'logo_klett-cotta.png', icon: 'logo_klett-cotta.png'},
                {link: 'https://www.le-tex.de', name: 'logo_klett.png', icon: 'logo_klett.png'},
                {link: 'https://www.le-tex.de', name: 'logo_knv.png', icon: 'logo_knv.png'},
                {link: 'https://www.le-tex.de', name: 'logo_kosmos.png', icon: 'logo_kosmos.png'},
                {link: 'https://www.le-tex.de', name: 'logo_kunstmann.png', icon: 'logo_kunstmann.png'},
                {link: 'https://www.le-tex.de', name: 'logo_luebbe.png', icon: 'logo_luebbe.png'},
                {link: 'https://www.le-tex.de', name: 'logo_luzern.png', icon: 'logo_luzern.png'},
                {link: 'https://www.le-tex.de', name: 'logo_mohr-siebeck.png', icon: 'logo_mohr-siebeck.png'},
                {link: 'https://www.le-tex.de', name: 'logo_oldenbourg.png', icon: 'logo_oldenbourg.png'},
                {link: 'https://www.le-tex.de', name: 'logo_oreilly.png', icon: 'logo_oreilly.png'},
                {link: 'https://www.le-tex.de', name: 'logo_pearsoneducation.png', icon: 'logo_pearsoneducation.png'},
                {link: 'https://www.le-tex.de', name: 'logo_piper_h.png', icon: 'logo_piper_h.png'},
                {link: 'https://www.le-tex.de', name: 'logo_random-house.png', icon: 'logo_random-house.png'},
                {link: 'https://www.le-tex.de', name: 'logo_schattauer.png', icon: 'logo_schattauer.png'},
                {link: 'https://www.le-tex.de', name: 'logo_springer.png', icon: 'logo_springer.png'},
                {link: 'https://www.le-tex.de', name: 'logo_suhrkamp.png', icon: 'logo_suhrkamp.png'},
                {link: 'https://www.le-tex.de', name: 'logo_sutton.png', icon: 'logo_sutton.png'},
                {link: 'https://www.le-tex.de', name: 'logo_swp.png', icon: 'logo_swp.png'},
                {link: 'https://www.le-tex.de', name: 'logo_thienemann.png', icon: 'logo_thienemann.png'},
                {link: 'https://www.le-tex.de', name: 'logo_uni-leipzig.png', icon: 'logo_uni-leipzig.png'},
                {link: 'https://www.le-tex.de', name: 'logo_unionsverlag.png', icon: 'logo_unionsverlag.png'},
                {link: 'https://www.le-tex.de', name: 'logo_v-r.png', icon: 'logo_v-r.png'},
                {link: 'https://www.le-tex.de', name: 'logo_vde.png', icon: 'logo_vde.png'},
                {link: 'https://www.le-tex.de', name: 'logo_vdf.png', icon: 'logo_vdf.png'},
                {link: 'https://www.le-tex.de', name: 'logo_wiley-vch.png', icon: 'logo_wiley-vch.png'}
            ])
        }
    },
    data: function(){
        return {
            
        };
    },
    methods: {
        
    },
    mounted: function (){
        
    },
    updated: function(){
        
    }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .carousel-3d-slide {
  background-color: inherit;
  border:none;
  }
  
  
  
.carousel-3d-container figure {
  margin:0;
}

.carousel-3d-container figure a img {

}
   a.next > span {
  line-height: 17px;
  }

  a.prev > span {
  line-height: 17px;
  }



  
  
</style>
